export type IonLinesType = 'default' | 'none' | 'full';
